<template>
  <v-container fluid>
    <h2 class="mb-3">Daily Attendance</h2>
    <v-card class="px-6 pb-0">
      <v-row>
        <v-col md="4" class="pb-0">
          <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                :value="dateFormatted"
                label="Select Date"
                prepend-icon="mdi-calendar"
                readonly
                v-on="on"
                color="primary"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="date"
              @change="onDateChange()"
              no-title
              scrollable
            ></v-date-picker>
          </v-menu>
        </v-col>
        <v-col md="3" offset-md="2">
          <v-text-field
            hide-details
            label="Find a user"
            prepend-icon="mdi-magnify"
            single-line
            v-model="search_string"
          ></v-text-field>
        </v-col>
        <v-col md="3" class="mt-4">
          <v-btn block outlined color="primary">
            <v-icon>mdi-download</v-icon>
            <download-excel
              :data="daily_activity"
              worksheet="Daily"
              name="Daily Activity Report.xls"
              >Download Report</download-excel
            >
          </v-btn>
        </v-col>
      </v-row>
    </v-card>

    <v-row>
      <v-col class="pt-0" md="6">
        <GmapMap
          class="mt-3"
          :center="mapCenter"
          :zoom="zoomLevel"
          map-type-id="terrain"
          style="height: 100%"
        >
          <GmapCluster>
            <GmapMarker
              v-for="m in activities"
              :key="m.type + m.timestamp + m.user_name"
              :position="{ lat: m.latitude, lng: m.longitude }"
              :clickable="true"
              @click="toggleInfo(m, m.user_name + m.timestamp)"
            />
            <GmapInfoWindow
              :options="info_options"
              :position="info_position"
              :opened="info_opened"
              @closeclick="info_opened = false"
              >{{ info_content }}</GmapInfoWindow
            >
          </GmapCluster>
        </GmapMap>
      </v-col>
      <v-col md="6">
        <v-row>
          <v-col md="12">
            <v-select
              :items="search_schedule"
              item-text="name"
              item-value="id"
              placeholder="Search Category"
            ></v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col md="6">
            <v-card>
              <v-list-item three-line>
                <v-list-item-content>
                  <v-list-item-title class="headline mb-1">
                    <v-icon medium color="success">mdi-location-enter</v-icon>
                    {{ checked_in }} / {{ total_employees }}
                  </v-list-item-title>
                  <v-list-item-subtitle class="success--text"
                    >Checked In</v-list-item-subtitle
                  >
                </v-list-item-content>
              </v-list-item>
            </v-card>
          </v-col>
          <v-col md="6">
            <v-card>
              <v-list-item three-line>
                <v-list-item-content>
                  <v-list-item-title class="headline mb-1">
                    <v-icon medium color="error">mdi-location-exit</v-icon>
                    {{ checked_out }} / {{ total_employees }}
                  </v-list-item-title>
                  <v-list-item-subtitle class="error--text"
                    >Checked Out</v-list-item-subtitle
                  >
                </v-list-item-content>
              </v-list-item>
            </v-card>
          </v-col>
        </v-row>
        <v-card height="600" max-height="100%" class="pb-0 overflow-y-auto">
          <v-simple-table v-if="!loading">
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">Type</th>
                  <th class="text-left">Full Name</th>
                  <th class="text-left">Time</th>
                  <th class="text-left">Timezone</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="item in filteredList"
                  :key="item.name"
                  @click="focusUser(item)"
                >
                  <td v-if="item.type === 'in'">
                    <v-icon color="success">mdi-location-enter</v-icon>
                  </td>
                  <td v-if="item.type === 'out'">
                    <v-icon color="error">mdi-location-exit</v-icon>
                  </td>
                  <td>{{ item.user_name }}</td>
                  <td>{{ toHours(item.group_timezone, item.timestamp) }}</td>
                  <td>{{ timezone(item.group_timezone) }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
          <v-skeleton-loader
            class="mx-auto"
            type="table-tbody"
            v-if="loading"
          ></v-skeleton-loader>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import firebase from "firebase";
import ENV from "./../store/modules/environtment";
import moment from "moment";
import axios from "axios";
import mt from "moment-timezone";
export default {
  name: "activity",
  data() {
    return {
      baseUrl: this.$store.state.baseUrl,
      date: new Date().toISOString().substr(0, 10),
      menu: false,
      info_marker: null,
      info_position: null,
      info_content: null,
      info_opened: false,
      info_current_key: null,
      info_options: {
        pixelOffset: {
          width: 0,
          height: -35,
        },
      },
      window_open: false,
      activities: [],
      daily_activity: [],
      loading: true,
      search_string: "",
      mapCenter: { lat: -6.266202, lng: 106.818325 },
      zoomLevel: 12,
      checked_in: 0,
      checked_out: 0,
      total_employees: 0,
      company_id: this.$store.state.company,
      page: 1,
      itemPerPage: 10,
      search_schedule: [
        { name: "Shifting", id: 0 },
        { name: "Regular", id: 1 },
      ],
    };
  },
  computed: {
    dateFormatted() {
      return this.date ? moment(this.date).format("dddd, MMMM Do YYYY") : "";
    },
    filteredList() {
      const search_string = this.search_string.toLowerCase();
      return this.activities.filter((item) =>
        item.user_name.toLowerCase().includes(search_string)
      );
    },
  },
  methods: {
    focusUser(user) {
      this.mapCenter = {
        lat: parseFloat(user.latitude),
        lng: parseFloat(user.longitude),
      };
      this.zoomLevel = 18;
      this.toggleInfo(user, user.user_name + user.timestamp);
    },
    timezone(item) {
      if (item == 7) {
        return "WIB";
      } else if (item == 8) {
        return "WITA";
      } else if (item == 9) {
        return "WIT";
      }
    },
    onDateChange() {
      this.menu = false;
      let date_start = moment(this.date, "YYYY-MM-DD").format("x");
      let date_end = moment(this.date)
        .add(1, "d")
        .subtract(1, "s")
        .format("x");
      this.fetchActivities(date_start, date_end);
    },
    todayDate() {
      return moment().format("DD-MM-YYYY");
    },
    toggleInfo(marker, key) {
      this.info_position = { lat: marker.latitude, lng: marker.longitude };
      this.info_content =
        this.toHours(marker.group_timezone, marker.timestamp) +
        " " +
        marker.user_name +
        " (" +
        marker.type +
        ")";
      if (this.info_current_key == key) {
        this.info_opened = !this.info_opened;
      } else {
        this.info_opened = true;
        this.info_current_key = key;
      }
    },
    toDate(time) {
      return moment(time).format("DD-MM-YYYY");
    },
    convertDate(time) {
      let convert = time.toString().split(" ");
      let hour = convert[4];
      return hour;
    },
    toHours(zone, time) {
      let utc = new Date(time).toUTCString();
      let tmp = "";
      if (zone === 7) {
        tmp = mt.tz(utc, "Asia/Jakarta");
      } else if (zone === 8) {
        tmp = mt.tz(utc, "Asia/Makassar");
      } else if (zone === 9) {
        tmp = mt.tz(utc, "Asia/Jayapura");
      }
      return this.convertDate(tmp);
    },
    fetchTotalEmployees() {
      const company_id = this.$store.state.company;
      const url = `${
        this.baseUrl
      }/user/countbycompanyid?companyId=${company_id}`;
      axios.get(url, { headers: { action: 'Get User Count by Company', actionId: 4 }}).then((res) => {
        this.total_employees = res.data.data;
      });
    },
    fetchActivities(date_start, date_end) {
      this.loading = true;
      const company_id = this.$store.state.company;
      const group_id = this.$store.state.group_id;
      let role = this.$store.state.role;
      if (role === 0 || role === 2) {
        firebase
          .firestore()
          .collection(ENV.firebase.attendance)
          .where("company_id", "==", company_id)
          .where("timestamp", ">", Number(date_start))
          .where("timestamp", "<", Number(date_end))
          .orderBy("timestamp", "desc")
          .onSnapshot((snapshot) => {
            this.activities = [];
            this.daily_activity = [];
            this.checked_in = 0;
            this.checked_out = 0;
            snapshot.forEach((doc) => {
              let attendance = doc.data();
              attendance.id = doc.id;

              if (attendance.type == "in") {
                this.checked_in += 1;
              }
              if (attendance.type == "out") {
                this.checked_out += 1;
              }
              this.activities.push(attendance);
            });
            snapshot.forEach((doc) => {
              let activity = {};
              let firebaseActivity = doc.data();
              activity.EmployeeCode = firebaseActivity.employee_code;
              activity.Group = firebaseActivity.group_id;
              activity.FullName = firebaseActivity.user_name;
              activity.CheckIn = this.toHours(
                firebaseActivity.group_timezone,
                firebaseActivity.timestamp
              );
              activity.GroupTimezone = this.timezone(
                firebaseActivity.group_timezone
              );
              if (firebaseActivity.type == "in") {
                this.daily_activity.push(activity);
              }
            });
            this.loading = false;
          });
      } else if (role === 3 || role === 4) {
        firebase
          .firestore()
          .collection(ENV.firebase.attendance)
          .where("group_id", "==", group_id)
          .where("timestamp", ">", Number(date_start))
          .where("timestamp", "<", Number(date_end))
          .orderBy("timestamp", "desc")
          .onSnapshot((snapshot) => {
            this.activities = [];
            this.daily_activity = [];
            this.checked_in = 0;
            this.checked_out = 0;
            snapshot.forEach((doc) => {
              let attendance = doc.data();
              attendance.id = doc.id;

              if (attendance.type == "in") {
                this.checked_in += 1;
              }
              if (attendance.type == "out") {
                this.checked_out += 1;
              }
              this.activities.push(attendance);
            });

            snapshot.forEach((doc) => {
              let activity = {};
              let firebaseActivity = doc.data();
              activity.EmployeeCode = firebaseActivity.employee_code;
              activity.Group = firebaseActivity.group_id;
              activity.FullName = firebaseActivity.user_name;
              activity.CheckIn = this.toHours(
                firebaseActivity.group_timezone,
                firebaseActivity.timestamp
              );
              activity.GroupTimezone = this.timezone(
                firebaseActivity.group_timezone
              );
              if (firebaseActivity.type == "in") {
                this.daily_activity.push(activity);
              }
            });
            this.loading = false;
          });
      }
    },
    fetchShiftSummary(page = 1, itemPerPage = 10) {
      this.page = page;
      this.itemPerPage = itemPerPage;
      const totalPageSend = itemPerPage < 1 ? this.totalData : itemPerPage;
      const start = this.page;
      const user_name = "dev";

      let url = `${this.baseUrl}/summary/getsummarydailyshifting?companyId=${
        this.company_id
      }&date=${
        this.date
      }&=userName${user_name}&=page${start}&=pageSize${totalPageSend}`;
      axios
        .get(url, { headers: { action: 'Get Summary', actionId: 4 } })
        .then((res) => {
          // eslint-disable-next-line no-console
          console.info(res.data.data);
        })
        .catch((err) => {
          // eslint-disable-next-line no-console
          console.error(err); // TODO: Add error toast message
        });
    },
  },
  created() {
    // let date = moment().format("DD-MM-YYYY");
    let date_start = moment(this.date).format("x");
    let date_end = moment(this.date)
      .add(1, "d")
      .subtract(1, "s")
      .format("x");
    this.fetchActivities(date_start, date_end);
    this.fetchTotalEmployees();
    this.fetchShiftSummary();
  },
};
</script>
<style>
#google-map {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  position: absolute;
  top: 0;
  z-index: 0;
}
#card {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 5;
}
</style>
